import { Component } from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-router-dom";

import ExternalLink from "../shared/ExternalLink";

export default class MobileNavBar extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    onClose: PropTypes.func
  };
  static defaultProps = {
    user: {}
  };

  render() {
    const { isOpen, items, onClose } = this.props;

    const mobileDropdownVisibleClasses = `z-[450] fixed w-full h-full top-0 left-0 right-0 transition-transform duration-[180ms] ease-in-out flex ${isOpen ? "translate-x-0" : "-translate-x-full"}`;
    const bottomItems = items
      .filter(item => item.dropdownContent)
      .reduce((accum, item) => {
        if (Array.isArray(item.dropdownContent)) {
          item.dropdownContent.forEach(dItem => {
            if (dItem) {
              accum.push(dItem);
            }
          });
        }
        return accum;
      }, []);
    return (
      <nav className={mobileDropdownVisibleClasses}>
        <div className="bg-white relative w-full max-w-[260px] z-[400] flex flex-col flex-1 min-h-0 overflow-hidden">
          <div className="overflow-auto flex-auto" style={{ paddingTop: "50px" }}>
            <ul className={`m-0 p-0 w-full bg-white block transition-all duration-150 ${isOpen ? "visible opacity-100" : "invisible opacity-0"}`} style={{ transitionTimingFunction: "cubic-bezier(0.25, 0, 0.25, 1.75)" }}>
              {items.map((item, i) => (
                <li
                  className={`relative ${item.isActive ? "bg-page-bg before:content-[''] before:absolute before:left-0 before:top-0 before:w-[3px] before:h-full before:bg-hex-337ab7" : ""}`}
                  key={`item-${i}`}
                  onClick={onClose}
                >
                  {item.linkTo ? (
                    <Link className={`block text-base p-5 font-normal cursor-pointer leading-normal transition-colors duration-200 hover:text-hex-337ab7 ${item.isActive ? "font-medium text-gray-800" : "text-gray-700"}`} to={item.linkTo}>
                      {item.label}
                    </Link>
                  ) : item.href ? (
                    <ExternalLink
                      className={`block text-base p-5 font-normal cursor-pointer leading-normal transition-colors duration-200 hover:text-hex-337ab7 ${item.isActive ? "font-medium text-gray-800" : "text-gray-700"}`}
                      href={item.href}
                    >
                      {item.label}
                    </ExternalLink>
                  ) : (
                    <a className={`block text-base p-5 font-normal cursor-pointer leading-normal transition-colors duration-200 hover:text-hex-337ab7 ${item.isActive ? "font-medium text-gray-800" : "text-gray-700"}`} onClick={item.onClick}>
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col flex-1 min-h-0 px-5 pb-2.5 justify-end">
            <ul className={`m-0 pt-2.5 w-full bg-white block border-t border-gray-200 transition-all duration-150 ${isOpen ? "visible opacity-100" : "invisible opacity-0"}`} style={{ transitionTimingFunction: "cubic-bezier(0.25, 0, 0.25, 1.75)" }}>
              {bottomItems.map((item, i) => {
                return (
                  <li
                    className={`relative ${
                      item.isActive ? "bg-page-bg before:content-[''] before:absolute before:left-0 before:top-0 before:w-[3px] before:h-full before:bg-hex-337ab7" : ""
                    } ${item.className || ""}`}
                    key={`bottom-item-${i}`}
                  >
                    <a className="block text-sm py-4 text-hex-337ab7 font-normal cursor-pointer leading-normal transition-colors duration-200 hover:text-hex-337ab7" href={item.href} onClick={item.onClick}>
                      {item.label}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className={`flex-1 min-h-0 bg-black/50 transition-all duration-100 ease-in-out ${isOpen ? "opacity-100 delay-200" : "opacity-0"}`} onClick={onClose} />
      </nav>
    );
  }
}
